<template>
  <div v-if="rating > 0" :class="score_prefix + ' ' + (direction === 'row' ? 'score--row' : '')">
    <span :class="score_prefix + '__number'">
      <span>{{ decimal_score }}</span>
    </span>
    <span :class="score_prefix + '__rank'" v-html="custom_textual_score(decimal_score)" />
  </div>
</template>

<script>
import { number } from 'mathjs'
export default {
  name: 'score',

  components: {
  },

  props: {
    rating: String,
    direction: {
      type: String,
      default: '',
    },
    floating: {
      type: Boolean, 
      default: false, 
    }
  },

  data() {
    return {
    }
  },

  computed: {
    decimal_score() {
      return number(this.rating)
    },

    custom_textual_score() {
      return this.textual_score()
    },

    score_prefix() {
      return (this.floating ? 'score-floating' : 'score');
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .score {
    $this: &;
    font-size: $font-size-md;
    position: absolute;
    top: 10px;
    z-index: 1;
    right: 10px;
    background: $white;
    padding: 3px 5px;
    border-radius: $border-radius;

    @include media-breakpoint-up(lg) {
      font-size: $font-size-base;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex-basis: 20%;
      text-align: center;
      position: static;
      background: transparent;
      padding: 0;

      &--row {
        align-items: center;
        flex-direction: row;
      }
    }

    &__number {
      color: var(--secondary);
      font-weight: $vb-font-weight-semibold;

      @include media-breakpoint-up(lg) {

        @at-root #{$this}--row & {
          order: 1;
          margin-left: $grid-gutter-width / 3
        }
      }

      span {
        @include media-breakpoint-up(lg) {
          display: inline-block;
          border-radius: 50%;
          background-color: var(--secondary);
          color: $white;
          width: $grid-gutter-width;
          height: $grid-gutter-width;
          line-height: $grid-gutter-width - 1;
        }
      }
    }

    &__rank {
      font-weight: $vb-font-weight-semibold;
      margin-left: $grid-gutter-width / 6;

      @include media-breakpoint-up(lg) {
        margin-left: 0;
      }
    }
  }

  .score-floating {
    $this: &;
    font-size: $font-size-md;
    position: absolute;
    top: 10px;
    z-index: 1;
    right: 10px;
    background: $white;
    padding: 3px 5px;
    border-radius: $border-radius;

    &__number {
      color: var(--secondary);
      font-weight: $vb-font-weight-semibold;
    }

    &__rank {
      font-weight: $vb-font-weight-semibold;
      margin-left: $grid-gutter-width / 6; 
    }
  }

</style>